import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { msg } from '@lingui/core/macro';
import { ceeElectricityUsageFields } from './common/electricityFields';

export const ceeElectricityUsageScope2Metadata = {
  displayName: msg({
    message: 'CEE Electricity Usage Scope 2',
    context: 'Activity data schema name for CEE Electricity Usage Scope 2',
  }),
  fields: {
    ...coreFields,
    ...ceeElectricityUsageFields,
  },
} as const satisfies BatMetadataConfigEntry;
